import { Button, Grid } from '@mui/material'
import { useFormContext } from 'react-hook-form'

import { ControlledDatePicker, ControlledSelector, ISelectorOptions } from 'components/common'
import { METRICS_MAX_DATE, METRICS_MIN_DATE } from 'constants/DateConstants'
import { DriverUserTypeFilter } from 'generated/graphql'

const USER_TYPE_OPTIONS: ISelectorOptions = [
  { value: DriverUserTypeFilter.AllJobs, label: 'All Jobs' },
  { value: DriverUserTypeFilter.AppUsers, label: 'App Users' },
  { value: DriverUserTypeFilter.NonAppUsers, label: 'Non-app Users' },
]

interface IProps {
  onClearAll: () => void
  onViewReport: () => void
}

const FilterCriteriaForm = ({ onClearAll, onViewReport }: IProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext()

  return (
    <Grid container spacing={3} alignItems='center'>
      <Grid item xs={2}>
        <ControlledDatePicker
          control={control}
          name='start'
          label='From'
          required
          minDate={METRICS_MIN_DATE}
          maxDate={METRICS_MAX_DATE}
          error={!!errors.start}
          helperText={errors.start?.message as string | undefined}
        />
      </Grid>

      <Grid item xs={2}>
        <ControlledDatePicker
          control={control}
          name='end'
          label='To'
          required
          minDate={METRICS_MIN_DATE}
          maxDate={METRICS_MAX_DATE}
          error={!!errors.end}
          helperText={errors.end?.message as string | undefined}
        />
      </Grid>

      <Grid item xs={2}>
        <ControlledSelector
          control={control}
          name='userType'
          label='User Type'
          options={USER_TYPE_OPTIONS}
        />
      </Grid>

      <Grid item xs={6}>
        <Grid container spacing={2} justifyContent='flex-end'>
          <Grid item>
            <Button variant='contained' color='grey' onClick={onClearAll}>
              Clear All
            </Button>
          </Grid>

          <Grid item>
            <Button variant='contained' color='primary' onClick={onViewReport}>
              View Report
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default FilterCriteriaForm
